// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordOptionsAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var PropTypes = require('react').PropTypes;
  var setPropTypes = require('recompose').setPropTypes;
  var UserAccountStore = require('logic/Izenda.UserAccountStore');
  var connect = require('share/enhancers/Izenda.Connect');
  var withHandlers = require('recompose').withHandlers;
  var fetcher = require('fetchers/Izenda.SystemSettingFetcher');
  var uiState = require('logic/Izenda.UiState');
  var MESSAGE = require('share/messages/Izenda.CommonMessages');
  var localizer = require('share/localization/Izenda.Localizer');
  const { curry } = require('lodash/fp');

  var passwordOptionsAction = compose(
    setPropTypes({
      store: PropTypes.object.isRequired
    }),
    connect(),
    withHandlers({
      onGeneratePasswordLink: curry(onGeneratePasswordLink),
      onCopyPasswordLink: curry(onCopyPasswordLink),
      updateSendEmailState: curry(updateSendEmailState),
      getRecipients: curry(getRecipients),
      addRecipients: curry(addRecipients),
      onClosing: curry(onClosing)
    })
  );

  /**
   * generate Password Link
   */
  function onGeneratePasswordLink(props, e) {
    var store = props.store;
    store.generatePasswordLink().then(function(result) {
      if (!result.success) {
        store.alertMessage = {
          type: 'error',
          message: result.messages
        };
      }
    });
  }

  /**
   * Copy Password Link
   */
  function onCopyPasswordLink(props, e) {
    var inputText = document.querySelector('#izenda-PasswordLinkCustom');
    if (inputText) {
      inputText.disabled = false;
      inputText.select();
      document.execCommand('copy');
      inputText.disabled = true;
    }
  }

  /**
   * Update state of sending email
   * @param props
   * @param state
   */
  function updateSendEmailState(props, state) {
    var store = props.store;
    var configUserCloned = store.configUserCloned;
    fetcher.isHavemailConfiguration(uiState.tenantId).then(function(result) {
      !result.success && props.confirmMessage('error', result.message);
      result.success && configUserCloned.updateSendEmailState(state);
    });
  }

  /**
   * get Recipients
   * @param  {array} userAccountList
   */
  function getRecipients(props, userAccountList) {
    var valManager = props.validation;
    valManager.reset();
    return props.store.configUserCloned.getRecipients(userAccountList);
  }

  /**
   * add Recipients
   * @param  {array} userAccountList
   */
  function addRecipients(props, userAccountList) {
    return props.store.configUserCloned.addRecipients(userAccountList);
  }

  /**
   * onClosing pop up
   * @param  {function} closeCallBack
   * @param  {string} type
   */
  function onClosing(props, closeCallBack, type) {
    var valManager = props.validation;
    var loader = props.loader;
    var onSavePassword = function(validateSuccess) {
      if (validateSuccess) {
        loader.startLoading();
        props.store
          .savePasswordOptions()
          .then(function(success) {
            return success && props.onAccept();
          })
          .finally(loader.endLoading.bind(loader));
      }
    };

    if (type === 'accept') {
      valManager.validate().then(onSavePassword);
    } else if (type === 'cancel') {
      props.store.configUserCloned.resetRecipientValue();
      props.store.configUserCloned.resetPasswordLink();
      props.onReject();
    }
  }

  module.exports = passwordOptionsAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/ActionBar/Izenda.PasswordOptionsAction.js